








































































import { Component, Vue } from 'vue-property-decorator';
import LeftAside from '@/components/menu/LeftAside.vue'; // @ is an alias to /src
import LogoCompany from '@/components/generics/LogoCompany.vue'; // @ is an alias to /src
import HeaderTop from '@/components/menu/header-top/HeaderTop.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';
import bus from "../../bus";
import Auth from "@/apiClient/Auth";
declare var mLayout: any;
import { helpHeroService } from '@/services/helpHeroService';
import { createKeepAlive, killKeepAlive, keepAliveExists } from '@/services/keepAliveService'
declare global {
  interface Window {
    companyIdAndName: string;
  }
}
@Component({
  name: 'Header',
  components: {
		LeftAside,
		LogoCompany,
	  	HeaderTop
  },
  computed: {
			...mapGetters(['getUser']),
			showNotifyPush: function(){
			return this.$store.state.notifyPushVisualizations === 1 && this.$store.state.notifyPush && (this.$route.name === 'home' || this.$store.state.notifyPush.sticky) && !sessionStorage.getItem('notifyPush')
		},
		companyLogo() {
			return this.$store.state.companyLogo;
		}
  },
  mounted(){
	  if(typeof mLayout !== 'undefined') mLayout.init();
  },
})
export default class Header extends Vue {
	shortname : string;
	name : string;
	lastname: string;
	email : string;
	code : string;
	companyName : string;
	companyID : string;
	$jwt : any;
	keepAliveInterval: any;
	id: Number;
	stateSideBar: boolean;
	componentKey: any;
  getUser!: any[];
  authClient: Auth;
  toggleIcon: boolean;
	companyIdAndName: string;

	beforeMount(){
		this.componentKey += 1;
		this.$forceUpdate()
	}

  mounted() {
    const bool = localStorage.getItem("boolean")
    this.toggleIcon = bool ? bool === "false" : true
		const { permissions } = this.$store.state;
		const { nombre, apellido, pais, id, company_has_manager_profile } = this.$store.state.user;
		const userData = {
			name: `${nombre} ${apellido}`,
			country: pais,
			userId: id,
			managerProfile: company_has_manager_profile || false,
			selfManagement: permissions.includes(200)
		}
		helpHeroService(userData);
  }

	data() {
		return {
			shortname : '',
			name : '',
			lastname : '',
			email : '',
			code : '',
			companyName : '',
			id: '',
			stateSideBar: JSON.parse(localStorage.getItem("boolean")),
			componentKey: 1,
			colours: {yellow: '#FF9B00', red: '#FF3D3E', blue:'#09A7F6' , green:'#54CAA6'},
      toggleIcon: false,
			companyIdAndName:''
		}
	}

	setStateBar() {

		var changeStateSideBar = !this.stateSideBar

		this.stateSideBar = changeStateSideBar

		localStorage.setItem('boolean',JSON.stringify(changeStateSideBar))

		if (typeof(Storage) !== "undefined") {
				if(!this.stateSideBar){
					localStorage.setItem("boolean", "false");

          document.body.classList.add("m-aside-left--minimize");
          document.body.classList.add("m-brand--minimize");

          this.toggleIcon = true
				}
				if(this.stateSideBar){
					localStorage.setItem("boolean", "true");

          document.body.classList.remove("m-aside-left--minimize");
          document.body.classList.remove("m-brand--minimize");

          this.toggleIcon = false
        }
		}
	}

  async created () {
    this.authClient = new Auth()
    if (this.$store.getters.getValidateSection) {
      try {
        await this.checkSessionStatus()
        if (keepAliveExists()) {
          killKeepAlive()
        }
        createKeepAlive(this.checkSessionStatus)
      } catch (e) {
        console.error(e)
      }
    }
    bus.$on("userchange", () => {
      this.id = this.$store.getters.getUser.id;
    });
    if(this.getUser){
      this.shortname = this.getUser['nombre'].charAt(0).toUpperCase() + this.getUser['apellido'].charAt(0).toUpperCase();
      this.name = this.getUser['nombre'];
      this.lastname = this.getUser['apellido'];
      this.email = this.getUser['mail'];
      this.code = this.getUser['cuil'];
      this.companyName = this.getUser['empresa'].nombre;
      this.id = this.$store.getters.getUser.id;
			this.companyID = this.getUser['empresa'].id;
			this.companyIdAndName = `${this.id} ${this.companyName}`;
			window.companyIdAndName = this.companyIdAndName;
			const event = new CustomEvent('companyNameSet', { detail: window.companyIdAndName });
				window.dispatchEvent(event);
			}
			        
			const storedConfig = localStorage.getItem('navBarConfig')
      const navBarConfig = storedConfig ? { ...JSON.parse(storedConfig) } : {}

      localStorage.setItem('navBarConfig', JSON.stringify({...navBarConfig, name: this.name, lastName: this.lastname, companyName: this.companyName }))

		this.setCompanyLogo();
  }

    async logout () {
      await this.authClient.logout();
      localStorage.removeItem('actions')
      localStorage.removeItem('jwt')
      localStorage.removeItem('user')
      sessionStorage.removeItem('notifyPush')
      localStorage.removeItem('hadModal')
      await this.logoutPHP()
      if (keepAliveExists()) killKeepAlive()
      await this.$store.dispatch('resetStore')
      this.$router.push('/login')
    }

  async checkSessionStatus () {
    try {
      const response = await this.authClient.keepAlive()
      if (response.status === 200) {
        await this.checkKeepAlivePHP()
      }
    } catch (error) {
      await this.handleUnauthorizedError(error, false)
    }
  }

  async checkKeepAlivePHP() {
    try {
      await axios.get(`${location.origin}/keepalive`)
    } catch (error) {
      await this.handleUnauthorizedError(error, true)
    }
  }

  async handleUnauthorizedError(error, api = false) {
    if (error.response && error.response.status === 401) {
      if (api) {
        await this.authClient.logout()
      } else {
        await this.logoutPHP()
      }
      await this.killSession()
      throw error
    }
  }

  async logoutPHP() {
    try {
      await axios.post(location.origin + `/salir`, null, { withCredentials: true })
    } catch (error) {
      console.error(error)
    }
  }

  async killSession() {
    killKeepAlive()
    localStorage.removeItem('jwt')
    localStorage.removeItem('user')
    localStorage.removeItem('actions')
    localStorage.removeItem('hadModal')
    await this.$store.dispatch('resetStore')
    this.$router.push('/login')
  }

		removeNotifyPush(){
			this.$store.dispatch('setNotifyPushVisualizations', 2);
			this.$store.dispatch('setNotifyPush', {});
			sessionStorage.setItem('notifyPush', 'false');
		}
		setCompanyLogo(){
			this.$store.dispatch('setCompanyLogo', this.companyID);
		}
}



